import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NativeAudio } from "@capacitor-community/native-audio";
import { WebsocketService } from "./services/wss.service";
import { IdleService } from "./services/idle.service";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AlertController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";

// export const serverUrl = 'http://localhost:3012/api';
export const serverUrl = "https://desarrollo.i4life.es/cerebro-en-casa/dev/api";

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
  standalone: false,
})
export class AppComponent implements OnInit {
  protected showRobotMovementScreen: boolean = false;
  public static webSocketService: WebsocketService;

  private robotKey: string = "";
  private robotSerie: string = "";
  private robotToken: string = "";

  constructor(
    private router: Router,
    private idleService: IdleService,
    private http: HttpClient,
    private alertController: AlertController,
    private translateService: TranslateService,
  ) {
    const availableLangs = ["es", "en", "pt"];

    this.translateService.addLangs(availableLangs);
    this.translateService.setFallbackLang("en");

    const browserLang = this.translateService.getBrowserLang();
    const browserCultureLang = this.translateService.getBrowserCultureLang();

    const lang =
      browserLang && availableLangs.includes(browserLang)
        ? browserLang
        : browserCultureLang && availableLangs.includes(browserCultureLang.split("-")[0])
          ? browserCultureLang.split("-")[0]
          : "en";

    this.translateService.use(lang);
  }

  async ngOnInit() {
    document.addEventListener("fullscreenchange", () => {
      if (document.fullscreenElement) {
        console.log("Entró en pantalla completa");
      } else {
        console.log("Salió de pantalla completa");
        this.alertController
          .create({
            backdropDismiss: false,
            message: this.translateService.instant("app.full_screen_stopped_msg"),
            header: this.translateService.instant("app.full_screen_stopped_header"),
            buttons: [
              {
                text: this.translateService.instant("app.full_screen_continue"),
                handler: async () => {
                  console.log("request fullscreen");
                  await document.querySelector("body")?.requestFullscreen();
                  console.log("fullscreen requested");
                },
              },
            ],
          })
          .then((alert) => alert.present());
      }
    });

    await new Promise((resolve) => {
      setTimeout(() => {
        resolve("");
      }, 1000);
    });

    this.alertController
      .create({
        message: this.translateService.instant("app.full_screen_greeting_msg"),
        backdropDismiss: false,
        header: this.translateService.instant("app.full_screen_greeting_header"),
        buttons: [
          {
            text: this.translateService.instant("app.full_screen_continue"),
            handler: async () => {
              console.log("request fullscreen");
              await document.querySelector("body")?.requestFullscreen();
              console.log("fullscreen requested");
            },
          },
        ],
      })
      .then((alert) => alert.present());

    if (!localStorage.getItem("access_token")) {
      console.log("No token found");
      this.router.navigate(["/login"]);
    } else {
      if (this.router.url === "/login") {
        this.router.navigate(["/"], { replaceUrl: true });
      }
    }

    this.robotKey = localStorage.getItem("robotKey") ?? "";
    this.robotSerie = localStorage.getItem("robotSerie") ?? "";

    NativeAudio.preload({
      assetId: "success_sound",
      assetPath: "success_sound.mp3",
      audioChannelNum: 1,
      isUrl: false,
    });
    NativeAudio.preload({
      assetId: "error_sound",
      assetPath: "error_sound.mp3",
      audioChannelNum: 1,
      isUrl: false,
    });
    let currentMode: "active" | "idle" = "idle";

    AppComponent.webSocketService = new WebsocketService();
    AppComponent.webSocketService.messages.subscribe((message) => {
      const event = message.data;
      currentMode = "idle";
      this.idleService.resetIdleTimer();

      if (event) {
        if (event.action === "open") {
          const baseUrl = decodeURIComponent(event.value);
          console.log(baseUrl);

          const [path, queryString] = baseUrl.split("?");
          const params = new URLSearchParams(queryString);
          console.log(path); // categorias/orientacion

          if (baseUrl.includes("standalone")) {
            console.log(params.get("ejercicio"));
            console.log(params.get("dificultad"));
            console.log(params.get("categoria"));

            this.router.navigate([path], {
              queryParams: {
                ejercicio: params.get("ejercicio"),
                dificultad: params.get("dificultad"),
                categoria: params.get("categoria"),
              },
            });
          } else {
            const [path, queryString] = baseUrl.split("?");
            const params = new URLSearchParams(queryString);
            console.log(params.get("game"));
            console.log(params.get("difficulty"));

            this.router.navigate([path], {
              queryParams: { game: params.get("game"), difficulty: params.get("difficulty") },
            });
          }
        } else if (event.action === "reload") {
          window.location.href =
            window.location.origin +
            window.location.pathname +
            window.location.search +
            (window.location.search ? "&" : "?") +
            "reloadTime=" +
            Date.now().toString() +
            window.location.hash;
        } else {
          if (event.action === "show_movement") this.showRobotMovementScreen = true;
          else if (event.action === "hide_movement") this.showRobotMovementScreen = false;
        }
      }
    });

    console.log("IDLE RObOT SERVICE SUbSCRIbING");
    this.idleService.onActive.subscribe((active) => {
      console.log("active trigger");
      if (currentMode !== "active") {
        console.log("App is in active mode");
        currentMode = "active";

        this.http
          .post(
            `https://desarrollo4.i4life.es/pam/${environment.production ? "prod" : "dev"}/robots/sendMessageToRobot`,
            {
              message: {
                event: "Events",
                channel: "robot",
                data: {
                  action: "image",
                  robot: this.robotSerie,
                  value: `https://desarrollo4.i4life.es/pam/${environment.production ? "prod" : "dev"}/images/happy_pam.png`,
                },
              },
              id: this.robotSerie,
            },
            { headers: new HttpHeaders({ "X-RKey": this.robotKey, "X-RSerie": this.robotSerie }) },
          )
          .subscribe({
            next: (response) => {
              console.log(response);
            },
            error: (error) => {
              console.error(error);
            },
          });
      }
    });
    this.idleService.onIdle.subscribe((idle) => {
      console.log("idle trigger");
      if (currentMode !== "idle") {
        console.log("App is in idle mode");
        currentMode = "idle";

        console.log("SENDING REQUEST -");
        this.http
          .post(
            `https://desarrollo4.i4life.es/pam/${environment.production ? "prod" : "dev"}/robots/sendMessageToRobot`,
            {
              message: {
                event: "Events",
                channel: "robot",
                data: {
                  action: "image",
                  robot: this.robotSerie,
                  value: `https://desarrollo4.i4life.es/pam/${environment.production ? "prod" : "dev"}/images/idle_pam.png`,
                },
              },
              id: this.robotSerie,
            },
            { headers: new HttpHeaders({ "X-RKey": this.robotKey, "X-RSerie": this.robotSerie }) },
          )
          .subscribe({
            next: (response) => {
              console.log(response);
            },
            error: (error) => {
              console.error(error);
            },
          });
      }
    });

    setTimeout(() => {
      this.idleService.startWatching();
    }, 500);
  }
}
